import { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../redux/index';
import { Link } from 'react-router-dom';
import PageContext from './PageContext';
import eyeIcon from '../../svgs/eye-details-icon.svg';
import PageTooltip from './PageTooltip';
import RowEditIcon from './RowEditIcon';
import minusIcon from '../../svgs/delete-bin-icon.svg';
import { TableCell } from '@mui/material';

// pass row object as prop
const CompanyProfileRow = ({ row, count, tableHeader, back, enableEdit,stickyEnabled }) =>{
    // get context variables from parent
    const {
        viewModal, 
        setViewModal, 
        viewCompany,  
        setViewCompany, 
        editModal, 
        setEditModal,
        editCompany, 
        setEditCompany, 
    } = useContext(PageContext);
    // redux state for use of persistant state in different route (CompanyDetailsPage)
    const company = useSelector((state) => state.company);
    const companyInfo = useSelector((state) => state.companyInfo);
    const backPath = useSelector((state) => state.backPath); 
    const dispatch = useDispatch();
    const { setCompany, setCompanyInfo, setBackPath } = bindActionCreators(actionCreators, dispatch);

    // event handler when link is clicked
    const onCompanyClick = (e) =>{
        // set back path to let navbar on next page to return 
        setBackPath(back); 
        // set company state to bring to new route
        setCompany(e.target.innerText.toString());
        setCompanyInfo(row);
    }

    // event handler for view icon click to show modal that lists sub companies
    const onViewClick = (e) => {
        setViewCompany(viewCompany => viewCompany = row);
        setViewModal(viewModal => viewModal = true);
    }

    // event handler for edit click 
    const onEditClick = () => {
        setEditCompany(editCompany => editCompany = row); 
        setEditModal(editModal => editModal = true); 
    }

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    return(
        <>
            {tableHeader.map(el => {
                // logic to determine how to display each column based on name
                if ( el['columnname'] == 'mastercompanyname' && row['userroleid']){
                    return(
                        <TableCell className={getRowClassName(el['columnorder'])}>
                            <Link onClick={(e)=>onCompanyClick(e)}
                                to={{
                                    pathname: "/CompanyDetailsPage",
                                }}>
                                {row[el['columnname']]}
                            </Link>
                        </TableCell>
                    );
                }
                else if (el['columnname'] == 'mastercompanyname'){
                    return(
                        <TableCell className={getRowClassName(el['columnorder'])}>
                            {row[el['columnname']]}
                        </TableCell>
                    );
                }
                else if (el['columnname'] == 'subcompanies'){
                    return (
                        <TableCell className={getRowClassName(el['columnorder'])}>                            
                            <PageTooltip title='view'>
                                <img src={eyeIcon} className='data-table-icon-left' onClick={(e)=>onViewClick(e)}/>
                            </PageTooltip>
                        </TableCell>
                    );
                }
                else if (el['columnname'] == 'blank')
                    return(
                        <TableCell>
                            {/* show edit icon to trigger EditSubCompanyRow modal */}
                            <RowEditIcon enable={enableEdit} onClick={onEditClick} icon={minusIcon} tooltip='remove' />
                        </TableCell>
                    );
                else if (row[el['columnname']] == null){
                    return(
                        <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
                    );
                }
                else{
                    return(
                        <TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>
                    );
                }
            })}
        </>
    );
}

export default CompanyProfileRow;